import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { ISettingRepository } from '@/coreInfrastructureModule/interfaces/ISettingRepository';
import { DashboardAlertSetting } from '../domains/entities/DashboardAlert';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';

/**
 * ダッシュボードアラート設定取得UseCase
 */
export class GetDashboardAlertSettingUseCase {
  private repository: ISettingRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: ISettingRepository) {
    this.repository = repository;
  }

  /**
   * ダッシュボードアラート設定を取得する
   */
  public async execute(): Promise<INetworkResult<DashboardAlertSetting, IError>> {
    try {
      const result = await this.repository.getDashboardAlertSetting();
      switch (result.status.type) {
        case 'success':
          return {
            status: {
              type: 'success',
              data: result.status.data,
            },
          };
        case 'error':
          console.error(result.status.error);
          return {
            status: {
              type: 'error',
              error: result.status.error,
            },
          };
      }
    } catch (e) {
      console.error('error', e); // 基本的にはここには来ない
      return {
        status: {
          type: 'error',
          error: {
            statusCode: 500,
            code: 'unknown',
            message: 'An unexpected error occurred',
          },
        },
      };
    }
  }
}
